import { render, staticRenderFns } from "./DonorFilter.vue?vue&type=template&id=c0dc3794"
import script from "./DonorFilter.vue?vue&type=script&lang=js"
export * from "./DonorFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports